import { lazy } from 'react';

// project-imports
import ErrorBoundary from './ErrorBoundary';
import { loader as productsLoader, productLoader } from 'api/products';
import Loadable from 'components/Loadable';
import { SimpleLayoutType } from 'config';
import DashboardLayout from 'layout/Dashboard';
import PagesLayout from 'layout/Pages';
import SimpleLayout from 'layout/Simple';
import ProjectMembers from 'pages/projects/detail/admin/forms/ProjectMembers';

// render - dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));


// render - applications
const AppChat = Loadable(lazy(() => import('pages/apps/chat')));
const AppBlog = Loadable(lazy(() => import('pages/apps/blog')));
const AppCalendar = Loadable(lazy(() => import('pages/apps/calendar')));
const AppsIndex = Loadable(lazy(() => import('pages/apps/index')));


const ProjectList = Loadable(lazy(() => import('pages/projects/index')));

const ProjectDetail = Loadable(lazy(() => import('pages/projects/detail')));
const ProjectDetailTabFollowerChat = Loadable(lazy(() => import('pages/projects/detail/sections/TabFollowerChat')));
const ProjectDetailTabTeamChat = Loadable(lazy(() => import('pages/projects/detail/sections/TabTeamChat')));

const ProjectManage = Loadable(lazy(() => import('pages/projects/detail/admin/list')));
const ProjectForm =  Loadable(lazy(() => import('pages/projects/detail/admin/addOrEdit')));
const ProjectManageDashboard = Loadable(lazy(() => import('pages/projects/detail/admin/dashboard')));
const ProjectManageMembers =  Loadable(lazy(() => import('pages/projects/detail/admin/members')));
const ProjectManageCart =  Loadable(lazy(() => import('pages/projects/detail/admin/cart')));
const ProjectManageLocation = Loadable(lazy(() => import('pages/projects/detail/admin/location')));
const ProjectManageUserInvitations = Loadable(lazy(() => import('pages/projects/detail/admin/userInvitation')));
const ProjectManageProducts = Loadable(lazy(() => import('pages/projects/detail/admin/market-products')));

const AppKanban = Loadable(lazy(() => import('pages/apps/kanban')));
const AppKanbanBacklogs = Loadable(lazy(() => import('sections/apps/kanban/Backlogs')));
const AppKanbanBoard = Loadable(lazy(() => import('sections/apps/kanban/Board')));

const AppCustomerList = Loadable(lazy(() => import('pages/apps/customer/list')));
const AppCustomerCard = Loadable(lazy(() => import('pages/apps/customer/card')));

const AppInvoiceCreate = Loadable(lazy(() => import('pages/apps/invoice/create')));
const AppInvoiceDashboard = Loadable(lazy(() => import('pages/apps/invoice/dashboard')));
const AppInvoiceList = Loadable(lazy(() => import('pages/apps/invoice/list')));
const AppInvoiceDetails = Loadable(lazy(() => import('pages/apps/invoice/details')));
const AppInvoiceEdit = Loadable(lazy(() => import('pages/apps/invoice/edit')));

const UserProfile = Loadable(lazy(() => import('pages/apps/profiles/user')));
const UserTabPersonal = Loadable(lazy(() => import('sections/apps/profiles/user/TabPersonal')));
const UserTabLocale = Loadable(lazy(() => import('sections/apps/profiles/user/TabLocale')));
const UserTabPayment = Loadable(lazy(() => import('sections/apps/profiles/user/TabPayment')));
const UserTabPassword = Loadable(lazy(() => import('sections/apps/profiles/user/TabPassword')));
const UserTabSettings = Loadable(lazy(() => import('sections/apps/profiles/user/TabSettings')));

const AccountProfile = Loadable(lazy(() => import('pages/apps/profiles/account')));
const AccountTabProfile = Loadable(lazy(() => import('sections/apps/profiles/account/TabProfile')));
const AccountTabPersonal = Loadable(lazy(() => import('sections/apps/profiles/account/TabPersonal')));
const AccountTabAccount = Loadable(lazy(() => import('sections/apps/profiles/account/TabAccount')));
const AccountTabPassword = Loadable(lazy(() => import('sections/apps/profiles/account/TabPassword')));
const AccountTabRole = Loadable(lazy(() => import('sections/apps/profiles/account/TabRole')));
const AccountTabSettings = Loadable(lazy(() => import('sections/apps/profiles/account/TabSettings')));

const UserHome = Loadable(lazy(() => import('pages/home')));
const UserHomeTabTimeline = Loadable(lazy(() => import('pages/home/sections/TabTimeline')));
const UserHomeTabProjects = Loadable(lazy(() => import('pages/home/sections/TabProjects')));
// const UserHomeTabFriendRequest = Loadable(lazy(() => import('pages/home/sections/TabFriendRequest')));
const UserHomeTabGallery = Loadable(lazy(() => import('pages/home/sections/TabGallery')));

const AppECommProducts = Loadable(lazy(() => import('pages/apps/e-commerce/product')));
const AppECommProductDetails = Loadable(lazy(() => import('pages/apps/e-commerce/product-details')));
const AppECommProductList = Loadable(lazy(() => import('pages/apps/e-commerce/products-list')));
const AppECommCheckout = Loadable(lazy(() => import('pages/apps/e-commerce/checkout')));
const AppECommAddProduct = Loadable(lazy(() => import('pages/apps/e-commerce/add-product')));

const AppFileManager = Loadable(lazy(() => import('pages/apps/file-manager')));
const AppMail = Loadable(lazy(() => import('pages/apps/mail')));



const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/error/404')));
const MaintenanceError500 = Loadable(lazy(() => import('pages/maintenance/error/500')));
const MaintenanceUnderConstruction = Loadable(lazy(() => import('pages/maintenance/under-construction/under-construction')));
const MaintenanceUnderConstruction2 = Loadable(lazy(() => import('pages/maintenance/under-construction/under-construction2')));
const MaintenanceComingSoon = Loadable(lazy(() => import('pages/maintenance/coming-soon/coming-soon')));
const MaintenanceComingSoon2 = Loadable(lazy(() => import('pages/maintenance/coming-soon/coming-soon2')));
const MaintenanceJoinWaitlist = Loadable(lazy(() => import('pages/maintenance/join-waitlist')));

// render - sample page
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));
const Landing = Loadable(lazy(() => import('pages/landing')));
const ContactUS = Loadable(lazy(() => import('pages/contact-us')));
// const ChangeLog = Loadable(lazy(() => import('pages/change-log')));
const ChangeLog = Loadable(lazy(() => import('pages/contact-us')));
const FaqPage = Loadable(lazy(() => import('pages/faqs')));
const PricingPage = Loadable(lazy(() => import('pages/extra-pages/price/price1')));
const PricingPage2 = Loadable(lazy(() => import('pages/extra-pages/price/price2')));

// ==============================|| MAIN ROUTES ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <DashboardLayout />,
      children: [

        {
          path: 'home',
          element: <UserHome />,
          children: [
            {
              path: 'timeline',
              element: <UserHomeTabTimeline />
            },
            {
              path: 'projects',
              element: <UserHomeTabProjects />
            },
            /* DISABLED - ADDING TO PROJECTS LIST
            {
              path: 'requests',
              element: <UserHomeTabFriendRequest />
            },
            */
            {
              path: 'calendar',
              element: <AppCalendar />
            },
            {/*
            {
              path: 'gallery',
              element: <UserHomeTabGallery />
            }
            */}
          ]
        },
        { path: 'page-not-found', element: <MaintenanceError /> },
        {
          path: 'projects',
          element: <PagesLayout />,
          children: [
            {
              index: true,
              element: <ProjectList />,
            },
            {
              path: ':project_guid',
              element: <ProjectDetail />,
              children: [
                {
                  path: 'follower-chat',
                  element: <ProjectDetailTabFollowerChat />
                },
                {
                  path: 'team-chat',
                  element: <ProjectDetailTabTeamChat />
                },                
                {
                  path: 'edit',
                  element: <ProjectForm />
                },
                {
                  path: 'members',
                  element: <ProjectManageMembers />
                },
                {
                  path: 'location',
                  element: <ProjectManageLocation />
                },
                {
                  path: 'apps',
                  element: <PagesLayout />,
                  children: [
                    {
                      index: true,
                      element: <AppsIndex />,
                    },
                    {
                      path: 'calendar',
                      element: <AppCalendar />
                    },
                    {
                      path: 'blog',
                      element: <AppBlog />
                    },
                  ]
                },

              ]
            }
          ]
        },
        {
          path: 'invitations',
          element: <PagesLayout />,
          children: [
            {
              path: ':member_guid',
              element: <PagesLayout />,
              children: [
                {
                  index: true,
                  element: <ProjectManageUserInvitations />,
                },
              ]
            },
          ],
        },
        {
          path: 'settings',
          children: [
            {
              path: 'profile',
              element: <UserTabPersonal />
            },
            {
              path: 'location',
              element: <UserTabLocale />
            },
            {
              path: 'password',
              element: <UserTabPassword />
            }
          ]
        },
        {
          path: 'adminDeprecated',
          children: [
            {
              path: 'profile',
              element: <UserTabPersonal />
            },
            {
              path: 'location',
              element: <UserTabLocale />
            },
            {
              path: 'password',
              element: <UserTabPassword />
            },
            {
              path: 'calendar',
              element: <AppCalendar />
            },
            {
              path: 'projects',
              element: <PagesLayout />,
              children: [
                {
                  index: true,
                  element: <ProjectManage />
                },
                {
                  path: 'add',
                  element: <ProjectForm />
                },
                {
                  path: ':project_guid',
                  element: <PagesLayout />,
                  children: [
                    {
                      index: true,
                      element: <ProjectManageDashboard />,
                    },
                    {
                      path: 'calendar',
                      element: <AppCalendar />
                    },
                    {
                      path: 'members',
                      element: <ProjectManageMembers />,
                    },
                    {
                      path: 'edit',
                      element: <ProjectForm />,
                    },
                    {
                      path: 'location',
                      element: <ProjectManageLocation />,
                    },
                    {
                      path: 'mail',
                      element: <AppMail />,
                    },
                    {
                      path: 'cart',
                      element: <ProjectManageCart />,
                    },
                    {
                      path: 'market',
                      element: <ProjectManageProducts />,
                    }
                  ]
                },
              ],
            },
            {
              path: 'invitations',
              element: <PagesLayout />,
              children: [
                {
                  path: ':member_guid',
                  element: <PagesLayout />,
                  children: [
                    {
                      index: true,
                      element: <ProjectManageUserInvitations />,
                    },
                  ]
                },
              ],
            }
          ]
        },
        {
          path: '__apps__',
          children: [
            {
              path: 'chat',
              element: <AppChat />
            },
            {
              path: 'kanban',
              element: <AppKanban />,
              children: [
                {
                  path: 'backlogs',
                  element: <AppKanbanBacklogs />
                },
                {
                  path: 'board',
                  element: <AppKanbanBoard />
                }
              ]
            },
            {
              path: '__invoice__',
              children: [
                {
                  path: 'dashboard',
                  element: <AppInvoiceDashboard />
                },
                {
                  path: 'create',
                  element: <AppInvoiceCreate />
                },
                {
                  path: 'details/:id',
                  element: <AppInvoiceDetails />
                },
                {
                  path: 'edit/:id',
                  element: <AppInvoiceEdit />
                },
                {
                  path: 'list',
                  element: <AppInvoiceList />
                }
              ]
            },
            {
              path: '__shopping__',
              children: [
                {
                  path: 'products',
                  element: <AppECommProducts />,
                  loader: productsLoader,
                  errorElement: <ErrorBoundary />
                },
                {
                  path: 'product-details/:id',
                  element: <AppECommProductDetails />,
                  loader: productLoader,
                  errorElement: <ErrorBoundary />
                },
                {
                  path: 'product-list',
                  element: <AppECommProductList />,
                  loader: productsLoader,
                  errorElement: <ErrorBoundary />
                },
                {
                  path: 'add-new-product',
                  element: <AppECommAddProduct />
                },
                {
                  path: 'checkout',
                  element: <AppECommCheckout />
                }
              ]
            },
            {
              path: '__file-manager__',
              element: <AppFileManager />
            },
            {
              path: '__mail__',
              element: <AppMail />
            }
          ]
        },
        {
          path: '___sample-page__',
          element: <SamplePage />
        },
        {
          path: '__price__',
          children: [
            {
              path: 'price1',
              element: <PricingPage />
            },
            {
              path: 'price2',
              element: <PricingPage2 />
            }
          ]
        }
      ]
    },
    {
      path: '/__',
      element: <SimpleLayout layout={SimpleLayoutType.LANDING} />,
      children: [
        {
          path: 'landing',
          element: <Landing />
        }
      ]
    },
    {
      path: '/__',
      element: <SimpleLayout />,
      children: [
        {
          path: 'contact-us',
          element: <ContactUS />
        }
      ]
    },

    {
      path: '/__',
      element: <SimpleLayout />,
      children: [
        {
          path: 'change-log',
          element: <ChangeLog />
        }
      ]
    },
    {
      path: '/__',
      element: <SimpleLayout />,
      children: [
        {
          path: 'faqs',
          element: <FaqPage />
        }
      ]
    },
    { path: '*', element: <MaintenanceError /> }
  ]
};

export default MainRoutes;
